$(function () {
  const haveReleasesInputSelector = "input[name=user_onboarding_form\\[have_releases\\]]";
  const haveReleasesCheckedInputSelector = `${haveReleasesInputSelector}:checked`;
  const $releaseFormTarget = $("[data-have-releases-target]");
  const setReleaseFormVisibility = function (visible) {
    visible === 'true' ? $releaseFormTarget.show() : $releaseFormTarget.hide();
  };

  setReleaseFormVisibility($(haveReleasesCheckedInputSelector).val());
  $(haveReleasesInputSelector).on('change', function () {
    setReleaseFormVisibility($(haveReleasesCheckedInputSelector).val())
  });

  const form = $('#new_user_onboarding_form');
  const modal = $('#terms-modal');
  const hasReleasesTrue = $("input[name=user_onboarding_form\\[have_releases\\]]");

  const contributorTermsInput = $('#user_onboarding_form_accepted_contributor_terms');

  const attachFormButtonSelector = '.poc-file-input .btn';

  hasReleasesTrue.on('change', function (e) {
    if ($(e.currentTarget).val() === "false") {
      $(attachFormButtonSelector).tooltip('dispose');
    }
  });

  modal.on('hidden.bs.modal', function (e) {
    contributorTermsInput.removeAttr('required')
  });

  modal.on('shown.bs.modal', function (e) {
    contributorTermsInput.attr('required', 'required')
  });

  const replaceAgreementData = function() {
    const firstName = $('#user_onboarding_form_first_name').val();
    const lastName = $('#user_onboarding_form_last_name').val();
    const phoneNumber = $('#user_onboarding_form_phone_number').val();
    const email = $('#user_onboarding_form_email').data('email');
    const date = $('#user_onboarding_form_date').data('date');
    const country = $('#user_onboarding_form_country').val();
    const city = $('#user_onboarding_form_city').val();
    const state = $('#user_onboarding_form_state').val();
    const postalCode = $('#user_onboarding_form_postal_code').val();
    const mailingAddressLine1 = $('#user_onboarding_form_mailing_address_line_1').val();
    const mailingAddressLine2 = $('#user_onboarding_form_mailing_address_line_2').val();

    $("#agreement_name").text(`${firstName} ${lastName}`);
    $("#agreement_phone_number").text(phoneNumber);
    $("#agreement_email").text(email);
    $("#agreement_date").text(date);
    $("#agreement_mailing_address").text([mailingAddressLine1, mailingAddressLine2, city, state, postalCode, country].join(", "))
  };

  $("#onboarding-continue-button").on('click', function (e) {
    e.preventDefault();

    if (form[0].reportValidity()) {
      const attachmentsCount = form.find('.poc-file-input input[type="file"]')[0].files.length;
      const shouldHaveReleases = hasReleasesTrue[0].checked;

      if (shouldHaveReleases && attachmentsCount === 0) {
        const attachFormButton = $(attachFormButtonSelector);
        attachFormButton.on('click', function () {
          attachFormButton.tooltip('dispose');
        });
        attachFormButton.tooltip({
          title: "Please attach a release form",
          trigger: 'manual'
        });
        attachFormButton.tooltip('show');
      } else {
        replaceAgreementData();
        modal.modal();
      }
    }
  })

});